import React from 'react';
import Header from "../components/home-7/Header";
import MobileMenu from "../components/header/MobileMenu";
import FooterDefault from "../components/footer/common-footer";
import Seo from "../components/common/Seo";
import Block0 from "./homepage/block0";
import Block1 from "./homepage/block1";
import Block2 from "./homepage/block2";
import Block3 from "./homepage/block3";
import Block4 from "./homepage/block4";
import Block5 from "./homepage/block5";
import Block6 from "./homepage/block6";
import Block7 from "./homepage/block7";
import Block8 from "./homepage/block8";
import Block9 from "./homepage/block9";

const Homepage = () => {

    return (
        <>
            <Seo
                pageTitle='Hotline Talents Handicap'
                pageDescription="Hotline Talents Handicap"
                pageUrl={window.location.href}
                imageUrl="/images/hotline-TH%201.png"
            />


            <Header secondLogo={false}/>

            <MobileMenu/>

            <Block0/>

            <Block1/>

            <Block2/>

            <Block3/>

            <Block4/>

            <Block5/>

            <Block6/>

            <Block7/>

            <Block8/>

            <Block9/>

            <FooterDefault footerStyle="style-six alternate -type-11"/>
        </>
    );
};

export default Homepage;
